import EventManager from '../__internals__/EventManager'
import { InternalAppTaskResultSchema } from '../__internals__/InternalAppTaskSchema'

enum TaskDoneEnum {
  addTaskSuccessEvent = 'addTaskSuccessEvent',
  addTaskFailEvent = 'addTaskFailEvent',
  addTaskCancelEvent = 'addTaskCancelEvent',
}

const taskDoneStatusEvents = {
  success: TaskDoneEnum.addTaskSuccessEvent,
  failure: TaskDoneEnum.addTaskFailEvent,
  cancel: TaskDoneEnum.addTaskCancelEvent,
}

const trackTaskDone =
  (eventManager: EventManager) => (taskData: InternalAppTaskResultSchema) => {
    const [, taskDoneEvent] =
      Object.entries(taskDoneStatusEvents).find(
        ([status]) => taskData.status === status,
      ) || []

    if (!taskDoneEvent) {
      throw new Error(
        `Please enter the task completion status: ${Object.keys(
          taskDoneStatusEvents,
        ).join(', ')}`,
      )
    }

    try {
      // Discard some global data between calls and return only what we care about
      const { ...retainedGlobalData } = eventManager.prepareDataLayer()

      // Set App related data along with just Task data on the Global Data layer
      // This will clear out anything else user set before
      const taskDoneJson = {
        ...eventManager.setAppDataAtGlobalDataLayer(retainedGlobalData),
        task: { ...taskData },
      }
      eventManager[taskDoneEvent](taskDoneJson)
    } catch (err) {
      // It turns out Firefly actually eats their own errors; if it has a CORS or other issue, this isn't triggered.
      console.warn(
        'An error occurred while sending an event to Firefly Internal Insights.',
      )
      if (process.env.NODE_ENV === 'development') {
        console.warn('Error:', err)
        console.warn('Task Data:', taskData)
      }
    }
  }

export default trackTaskDone
